import { PropTypes } from "prop-types"
import classNames from "classnames"

export function Label({ inputId, id, required, children, className, ...otherProps }) {
  return (
    <label className={classNames("oj-label", className)} htmlFor={inputId} id={id} {...otherProps}>
      {children}
    </label>
  )
}

Label.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.string,
  inputId: PropTypes.string,
  required: PropTypes.bool
}

export default Label
